import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, CountOfUsages, CasesearchViewLogsCount } from "../store_types"
import { callCountOfUsagesAPI, callCountRegistrationsAPI, callTotalCountRegistrationsAPI, callDownloadResponseResultsAPI, callCountCasesearchViewLogsAPI } from "../../api/response_results"
import { AxiosResponseHeaders } from "axios"
import { saveAs } from "file-saver"

const getDefaultState  = () => {
  return {
    countOfUsages : null,
    allRegistrationCount : null,
    targetMonthRegistrationCount : null,
    targetMonthSyounikaRegistrationCount : null,
    targetMonthObstetricsRegistrationCount : null,
    casesearchViewLogsCount: null
  }
}

const reseponseResults = {
  state: () => getDefaultState(),

  getters: {
    countOfUsages (state : State) {
      return state.countOfUsages
    },
    allRegistrationCount (state : State) {
      return state.allRegistrationCount
    },
    targetMonthRegistrationCount (state : State) {
      return state.targetMonthRegistrationCount
    },
    targetMonthSyounikaRegistrationCount (state : State) {
      return state.targetMonthSyounikaRegistrationCount
    },
    targetMonthObstetricsRegistrationCount (state : State) {
      return state.targetMonthObstetricsRegistrationCount
    },
    casesearchViewLogsCount (state : State) {
      return state.casesearchViewLogsCount
    },
  },

  actions: {
    fetchUsageCounts({ commit, getters }: { commit: (mutationType:string, result: AxiosResponseHeaders | CountOfUsages) => void, getters: { [authHeaders: string]: AuthHeaders | number | Date }}){
      if(getters.selectedCorporationId === null) return
      return new Promise<void>((resolve, reject) => {
        // 指定企業の登録数取得
        callCountOfUsagesAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedHomeDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, countOfUsages: CountOfUsages) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_USAGES_COUNT, countOfUsages)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    fetchRegistrationCounts({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | number) => void, getters: { [authHeaders: string]: AuthHeaders | number | Date }}){
      if(getters.selectedCorporationId === null) return
      return new Promise<void>((resolve, reject) => {
        // 指定企業の登録数取得
        callCountRegistrationsAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedHomeDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, targetMonthRegistrationCount: number, targetMonthSyounikaRegistrationCount: number, targetMonthObstetricsRegistrationCount: number) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_TARGET_MONTH_REGISTRATION_COUNT, targetMonthRegistrationCount)
            commit(MutationTypes.ASSIGN_TARGET_MONTH_SYOUNIKA_REGISTRATION_COUNT, targetMonthSyounikaRegistrationCount)
            commit(MutationTypes.ASSIGN_TARGET_MONTH_OBSTETRICS_REGISTRATION_COUNT, targetMonthObstetricsRegistrationCount)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    fetchTotalRegistrationCounts({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | number) => void, getters: { [key: string]: AuthHeaders| number }}){
      if(getters.selectedCorporationId === null) return
      return new Promise<void>((resolve, reject) => {
        // 指定企業の登録数取得
        // TODO 期間のパラメーターを後で追加する
        callTotalCountRegistrationsAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number
          },
          // Success
          (headers: AxiosResponseHeaders, allRegistrationCount: number) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_ALL_REGISTRATION_COUNT, allRegistrationCount)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    downloadResponseResults({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callDownloadResponseResultsAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedHomeDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, csvData: Blob) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            const targetMonth = getters.selectedHomeDate as Date
            saveAs(csvData, `登録・利用状況_${targetMonth.getFullYear()}年${targetMonth.getMonth() + 1}月.csv`)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    fetchCasesearchViewLogsCount({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | CasesearchViewLogsCount) => void, getters: { [authHeaders: string]: AuthHeaders | number | Date }}){
      if(getters.selectedCorporationId === null) return
      return new Promise<void>((resolve, reject) => {
        callCountCasesearchViewLogsAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedHomeDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, casesearchViewLogsCount: CasesearchViewLogsCount) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_CASESEARCH_VIEW_LOGS_COUNT, casesearchViewLogsCount)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    resetReseponseResultsState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_RESPONSE_RESULT_STATE)
    },
  },

  mutations: {
    [MutationTypes.ASSIGN_USAGES_COUNT](state: State, countOfUsages: CountOfUsages) {
      state.countOfUsages = countOfUsages
    },
    [MutationTypes.ASSIGN_ALL_REGISTRATION_COUNT](state: State, allRegistrationCount: number) {
      state.allRegistrationCount = allRegistrationCount
    },
    [MutationTypes.ASSIGN_TARGET_MONTH_REGISTRATION_COUNT](state: State, targetMonthRegistrationCount: number) {
      state.targetMonthRegistrationCount = targetMonthRegistrationCount
    },
    [MutationTypes.ASSIGN_TARGET_MONTH_SYOUNIKA_REGISTRATION_COUNT](state: State, targetMonthSyounikaRegistrationCount: number) {
      state.targetMonthSyounikaRegistrationCount = targetMonthSyounikaRegistrationCount
    },
    [MutationTypes.ASSIGN_TARGET_MONTH_OBSTETRICS_REGISTRATION_COUNT](state: State, targetMonthObstetricsRegistrationCount: number) {
      state.targetMonthObstetricsRegistrationCount = targetMonthObstetricsRegistrationCount
    },
    [MutationTypes.RESET_RESPONSE_RESULT_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
    [MutationTypes.ASSIGN_CASESEARCH_VIEW_LOGS_COUNT](state: State, casesearchViewLogsCount: CasesearchViewLogsCount) {
      state.casesearchViewLogsCount = casesearchViewLogsCount
    },
  },
}

export default reseponseResults
